import type { OpportunityTask } from 'backend/types'
import { DateTime } from 'luxon'

export const excelColumns: { label: string; accessor: (row: OpportunityTask) => unknown }[] = [
  { label: 'タスク管理ID', accessor: (row) => row.id },
  { label: 'オポチュニティ管理ID', accessor: (row) => row.opportunity_id },
  { label: 'オポチュニティタイトル', accessor: (row) => row.opportunity_title },
  { label: 'オポステータス管理ID', accessor: (row) => row.opportunity_status_id },
  { label: 'オポステータス名', accessor: (row) => row.opportunity_status_name },
  { label: 'SFプロジェクト管理ID', accessor: (row) => row.salesforce_project_id },
  { label: 'SFプロジェクト名', accessor: (row) => row.salesforce_project_name },
  { label: 'メンバー管理ID', accessor: (row) => row.member_id },
  { label: '従業員番号', accessor: (row) => row.member_employee_number },
  { label: '従業員名', accessor: (row) => row.member_name },
  { label: 'タスクタイトル', accessor: (row) => row.title },
  { label: 'タスクの詳細', accessor: (row) => row.description },
  { label: 'タスクステータス管理ID', accessor: (row) => row.opportunity_task_status_id },
  { label: 'タスクステータス名', accessor: (row) => row.opportunity_task_status_name },
  {
    label: 'タスクの期日',
    accessor: (row) => {
      if (!row.expired_on) return null
      const dt = DateTime.fromISO(row.expired_on)
      return dt.isValid ? dt.toFormat('yyyy/MM/dd') : null
    },
  },
  { label: 'タスク最終更新者管理ID', accessor: (row) => row.updated_by },
  { label: 'タスク最終更新者従業員番号', accessor: (row) => row.updated_by_employee_number },
  { label: 'タスク最終更新者', accessor: (row) => row.updated_by_name },
  { label: 'タスク作成者管理ID', accessor: (row) => row.created_by },
  { label: 'タスク作成者従業員番号', accessor: (row) => row.created_by_employee_number },
  { label: 'タスク作成者', accessor: (row) => row.created_by_name },
  {
    label: '更新日時',
    accessor: (row) => {
      if (!row.updated_at) return null
      const dt = DateTime.fromSeconds(Number(row.updated_at))
      return dt.isValid ? dt.toFormat('yyyy/MM/dd HH:mm:ss') : null
    },
  },
  {
    label: '作成日時',
    accessor: (row) => {
      if (!row.created_at) return null
      const dt = DateTime.fromSeconds(Number(row.created_at))
      return dt.isValid ? dt.toFormat('yyyy/MM/dd HH:mm:ss') : null
    },
  },
]
